// extracted by mini-css-extract-plugin
module.exports = {"sponsorBlock":"movie-provider-banner_sponsorBlock__4G3JB"};